<template>
    <div class="client-section pt-100 pb-70" style="background: white;">
        <div class="container">
            <div class="section-title section-title-lg">
                <small>{{ $t('home.clients.subtitle') }}</small>
                <h2>{{ $t('home.clients.title') }}</h2>
            </div>
            <div class="client-content">
                <div class="row justify-content-center">
                    <div class="col-sm-6 col-lg-4 pb-30">
                        <div class="client-item client-item-center border">
                            <div class="client-thumb">
                                <img v-lazy="$ossImg('client/client-1.png')" :alt="$t('home.clients.alt.clientGeneric')">
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-lg-4 pb-30">
                        <div class="client-item client-item-center border">
                            <div class="client-thumb">
                                <img v-lazy="$ossImg('client/client-2-1.png')" :alt="$t('home.clients.alt.csscLogo')" class="client-2-1">
                                <img v-lazy="$ossImg('client/client-2-2.png')" :alt="$t('home.clients.alt.cssc')" class="client-2-2">
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-lg-4 pb-30">
                        <div class="client-item client-item-center border">
                            <div class="client-thumb">
                                <img v-lazy="$ossImg('client/client-3.png')" :alt="$t('home.clients.alt.clientGeneric')">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Client'
}
</script>

<style scoped>
.client-item {
    box-shadow: 5px 10px 16.6px 0 rgba(122, 151, 177, 0.25);
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: white;
    border-radius: 8px;
    padding: 20px;
}

.client-thumb {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.client-thumb img {
    object-fit: contain;
}

/* First client logo */
.client-item:nth-child(1) .client-thumb {
    width: 313px;
    height: 108px;
}

/* Second client logo */
.client-2-1 {
    width: 112.325px;
    height: 27.323px;
}

.client-2-2 {
    width: 409.226px;
    height: 27.323px;
}

/* Third client logo */
.client-item:nth-child(3) .client-thumb {
    width: 196px;
    height: 120px;
}
</style>
